import React from 'react'

import { useSiteMetadata } from '@models/Util'

type MetaType = {
  name?: string
  property?: string
  content: string
}

type SeoProps = {
  pathName: string
  title?: string
  description?: string
  imageUrl?: string
}

const Seo: React.FC<SeoProps> = ({
  pathName,
  title,
  description,
  imageUrl,
}) => {
  const { title: siteTitle, siteUrl } = useSiteMetadata()
  const locale = pathName.startsWith('/en') ? 'en' : 'ja'
  const siteDescription =
    locale === 'en'
      ? 'ZOZO NEXT will provide a unique perspective on fashion x technology news from Japan and abroad.'
      : '国内外のファッション×テクノロジーのニュースを、ZOZO NEXTが独自の視点で発信していきます。'

  const pageUrl = siteUrl + pathName
  const titleWithFTN = !title ? siteTitle : `${title} | ${siteTitle}`
  const descriptionFull = !description ? siteDescription : description
  const imageUrlFull = !imageUrl ? `${siteUrl}/ogp.jpg` : imageUrl

  const concatMetas: MetaType[] = [
    // Page
    {
      name: 'description',
      content: descriptionFull,
    },
    // Twitter
    {
      name: 'twitter:title',
      content: titleWithFTN,
    },
    {
      property: 'twitter:description',
      content: descriptionFull,
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
    {
      property: 'twitter:image',
      content: imageUrlFull,
    },
    // OpenGraph metadata properties
    {
      property: 'og:title',
      content: titleWithFTN,
    },
    {
      property: 'og:description',
      content: descriptionFull,
    },
    {
      property: 'og:url',
      content: pageUrl,
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      property: 'og:image',
      content: imageUrlFull,
    },
    // Facebook
    {
      property: 'fb:app_id',
      content: '665869046808089',
    },
  ]

  return (
    <>
      <title>{titleWithFTN}</title>

      {concatMetas.map((meta, index) => (
        <meta
          name={meta.name}
          property={meta.property}
          content={meta.content}
          key={index}
        />
      ))}

      <link rel="apple-touch-icon" href="icons/icon-48x48.png" sizes="48x48" />
      <link rel="apple-touch-icon" href="icons/icon-72x72.png" sizes="72x72" />
      <link rel="apple-touch-icon" href="icons/icon-96x96.png" sizes="96x96" />
      <link
        rel="apple-touch-icon"
        href="icons/icon-144x144.png"
        sizes="144x144"
      />
      <link
        rel="apple-touch-icon"
        href="icons/icon-192x192.png"
        sizes="192x192"
      />
      <link
        rel="apple-touch-icon"
        href="icons/icon-256x256.png"
        sizes="256x256"
      />
      <link
        rel="apple-touch-icon"
        href="icons/icon-384x384.png"
        sizes="384x384"
      />
      <link
        rel="apple-touch-icon"
        href="icons/icon-512x512.png"
        sizes="512x512"
      />
    </>
  )
}

export default Seo
